export default __webpack_public_path__ + "static/media/bench-window-back-rounded-top.3a4a37f3.webp";